import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { IAgent, IAgentForSettingsView, IMachineFromApi } from 'app/models';
import { MachineService } from 'app/services';
import { AgentService } from 'app/services';
import { MessageService } from 'app/services/message/message.service';
import { Observable } from 'rxjs';
import { AgentMngtDetailComponent } from '../agent-mngt-detail/agent-mngt-detail.component';
import {
  AgentPwdGenDialogComponent,
  AgentPwdGenDialogModel,
} from '../agent-pwd-gen-dialog/agent-pwd-gen-dialog.component';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from '../confirm-dialog/confirm-dialog.component';
import { AbstractSettingsFilteredTableComponent } from '../setting-mngt-filtered-table';

@Component({
  selector: 'app-agent-mngt',
  templateUrl: './agent-mngt.component.html',
  styleUrls: ['./agent-mngt.component.scss'],
})
export class AgentMngtComponent extends AbstractSettingsFilteredTableComponent<IAgentForSettingsView> implements OnInit {
  @ViewChild(AgentMngtDetailComponent)
  private agentMngtDetailComponent!: AgentMngtDetailComponent;

  machines: IMachineFromApi[] = [];
  displayedColumns = [
    'username',
    'machine',
    'enabled',
    'lastSeenOnline',
    'Actions',
  ];

  dataSource = new MatTableDataSource<IAgentForSettingsView>();

  constructor(
    private agentService: AgentService,
    private machineService: MachineService,
    public dialog: MatDialog,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit() {
    this.getIMachines();
    this.getIAgents();
  }

  onAgentSaved(saved: boolean) {
    const msg: string = saved
      ? ` Agent correctly saved `
      : ` Agent NOT correctly saved `;
    this.messageService.showDirectSimpleMessage(msg);
    this.getIAgents();
  }

  getIAgents(): void {
    this.agentService.getIAgents().subscribe(
      (agents) => {
        const viewAgents: IAgentForSettingsView[] = agents.map(
          currentAgent => {
            (currentAgent as IAgentForSettingsView).machineSerialNumber = this.getMachineById(currentAgent.machineId)?.serialNumber;
            return currentAgent;
          }
        );
        this.dataSource.data = viewAgents;
      },
      () =>
        this.messageService.showDirectSimpleMessage(` Loading agents error `)
    );
  }

  getIMachines(): void {
    this.machineService.findAllMachines().subscribe(
      (machines) => (this.machines = machines.sort((a, b) => (a.serialNumber < b.serialNumber) ? -1 : 1)),
      () =>
        this.messageService.showDirectSimpleMessage(` Loading machines error `)
    );
  }

  getMachineById(id: number): IMachineFromApi | undefined {
    return this.machines.find((item) => item.id === id);
  }

  delete(agent: IAgent): Observable<IAgent> {
    return this.agentService.deleteIAgent(agent.id);
  }

  deleteConfirmDialog(agentToBeDeleted: IAgent): void {
    const message = `Are you sure you want to delete the agent with username ${agentToBeDeleted.username} ?`;
    const dialogData = new ConfirmDialogModel('Confirm Delete Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.delete(agentToBeDeleted).subscribe(
          () => this.messageService.showDirectSimpleMessage(` Agent deleted `),
          () =>
            this.messageService.showDirectSimpleMessage(` Agent delete error `),
          () => this.getIAgents()
        );
      }
    });
  }

  generatePwdConfirmDialog(agentToGeneratePwd: IAgent): void {
    const dialogData = new AgentPwdGenDialogModel(
      agentToGeneratePwd,
      this.getMachineById(agentToGeneratePwd.machineId)
    );
    this.dialog.open(AgentPwdGenDialogComponent, {
      data: dialogData,
    });
  }

  edit(agent: IAgent): void {
    this.agentMngtDetailComponent.initEdit(agent);
  }
}
